import {Box, CircularProgress, useTheme} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";
import {useEffect, useState} from "react";
import styles from "./ListView.module.css";

const ListView = ({columns, data, loading, onRowClick, TopRigthButtons, getRowId}) => {
  const theme = useTheme();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (data) {
      setRows(data);
    }
  }, [data]);

  return (
    <>
      {loading ? (
        <CircularProgress size={300} color={theme.palette.primary.main} />
      ) : (
        <Box className={styles.container}>
          <header className={styles.header}>{TopRigthButtons}</header>
          <DataGrid
            className={styles.dataGrid}
            rows={rows}
            columns={columns}
            getRowId={getRowId}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10
                }
              },
              pinnedColumns: {right: ["actions"]}
            }}
            pageSizeOptions={[10]}
            disableRowSelectionOnClick
            onRowClick={(params) => {
              if (onRowClick) {
                onRowClick(params.row);
              }
            }}
          />
        </Box>
      )}
    </>
  );
};

export default ListView;
